/**
 * 微信文章排行
 * 2017-11-21
 * Bai.Zhiming
 */
"use strict";
angular.module("weixinArticleListModule", []).
controller("weixinArticleListCtrl", ["$scope", "trsHttpService", "$q", "$element", function($scope, trsHttpService, $q, $element) {
    initStatus();
    initData();
    /**
     * [initStatus description]初始化状态
     */
    function initStatus() {
        $scope.status = {
            //初始化小图长宽高度
            initSmallRankingwidth: {
                height: '30px',
                width: '100px'
            },
            //初始化大图长宽
            initBigRankingwidth: {
                height: '240px',
                width: '1000px'
            },
            //初始化热度曲线
            readCurve: '',
            selectWeChatTitletab: '',
            selectrankingTab: '',
            weChatRankDate: moment(new Date()).format("YYYY-MM-DD"),
            isInit: true,
            jumpToPageNum: 1,
        };
        $scope.data = {};
        $scope.page = {
            startpage: 1,
            PAGESIZE: 20
        };
    }
    /**
     * [initStatus description]初始化数据
     */
    function initData() {
        //初始化获取一级标签数据
        getWetChaTtitletab();
        weChatTitletab();
        //初始化获取二级标签数据
        // $scope.weChatTitletab($scope.status.rankingTitle[0]);
        $scope.$watch("status.weChatRankDate", function(newV) {
            newV = moment(newV).format("YYYY-MM-DD");
            if (!$scope.status.isInit && newV !== $scope.status.weChatRankDate) {
                $scope.status.weChatRankDate = newV;
                $scope.weChatRanklistTab($scope.status.selectrankingTab, 'changeTab');
            }
            $scope.status.isInit = false;
        });
    }
    /**
     * [getWetChaTtitletab description]获取一级标签
     * 
     */
    function getWetChaTtitletab() {
        $scope.status.rankingTitle = [{ value: 0, name: '文章' }, { value: 1, name: '公众号' }];
        $scope.status.selectWeChatTitletab = $scope.status.rankingTitle[0].value;
    }
    /*
     *[  weChatTitletab description] 获取二级导航
     *@params   [description]
     */
    function weChatTitletab() {
        var params = {
            typeid: "widget",
            serviceid: "weixinrank",
            modelid: "catalog",
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get")
            .then(function(data) {
                $scope.data.rankingTabListNum = data;
                $scope.weChatRanklistTab(data[0]);
            });
    }
    /*
     *[  readCurve description] 门户排行榜阅读曲线
     *@params item   [description]标题名称
     */
    $scope.readCurve = function(item) {
        $scope.status.readCurve = (($scope.status.readCurve == item) ? '' : item);
    };
    /**
     * [titletab description]选择一级标签，获取二级标签列表
     * 
     */
    $scope.weChatTitletab = function(title) {
        if ($scope.status.selectWeChatTitletab == title.value) { return };
        $scope.status.selectWeChatTitletab = title.value;
        $scope.weChatRanklistTab($scope.data.rankingTabListNum[0], 'changeTab');
    };
    $scope.weChatRanklistTab = function(rankingTabList, changeTab) {
        $scope.status.jumpToPageNum = angular.isDefined(changeTab) ? 1 : $scope.status.jumpToPageNum;
        $scope.status.selectrankingTab = rankingTabList;
        var modelid = 'doc';
        if ($scope.status.selectWeChatTitletab === 1) {
            modelid = 'author';
        }
        var params = {
            typeid: "widget",
            serviceid: "weixinrank",
            modelid: modelid,
            catalogid: rankingTabList.CATALOGID,
            page_no: angular.isDefined(changeTab) ? 0 : $scope.page.startpage - 1,
            page_size: $scope.page.PAGESIZE
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get")
            .then(function(data) {
                $scope.data.ranklistLists = data.PAGEITEMS;
                $scope.page = {
                    startpage: data.STARTPAGE + 1,
                    PAGESIZE: data.PAGESIZE,
                    ITEMCOUNT: data.TOTALITEMCOUNT,
                    PAGECOUNT: data.TOTALPAGECOUNT
                };
                $element.find(".view_content_text").animate({ scrollTop: 0 }, 200);
            });
    };
    /**
     * [pageChanged description]分页
     * @return {[type]} [description]
     */
    $scope.pageChanged = function() {
        $scope.status.jumpToPageNum = $scope.page.startpage;
        $scope.weChatRanklistTab($scope.status.selectrankingTab);
    };
    $scope.jumpToPage = function() {
        if ($scope.status.jumpToPageNum > $scope.page.PAGECOUNT) {
            $scope.status.jumpToPageNum = $scope.page.PAGECOUNT;
        }
        $scope.params.page_no = $scope.status.jumpToPageNum - 1;
        $scope.page.startpage = $scope.status.jumpToPageNum;
        $scope.weChatRanklistTab($scope.status.selectrankingTab);
    };
    /**
     * [ranklistTab description]选择二级标签
     * 
     */
    $scope.ranklistTab = function() {};
}]);